module.exports = __webpack_public_path__ + "img/bk.cc3a79b9.png";